import script from "./goRinSyo0015.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0015.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0015.vue?vue&type=style&index=0&id=396c64b0&lang=scss"

const __exports__ = script;

export default __exports__